<template>
  <ModalUi @closeModal="toggleModals()">
    <div class="modal-wrap">
      <div class="modal-block">
        <div class="modal-title">
          <h3>Выбрать штатного курьера</h3>
        </div>
        <button class="close" @click="toggleModals()" type="button">
          <img src="/images/redesignedForm/close-button.svg" alt="close" />
        </button>
        <hr class="line" />
        <div v-if="filteredLocalCrmList.length" class="modal-content">
          <ul class="couriers">
            <li v-for="courier in filteredLocalCrmList" :key="courier.cid" class="courier">
              <label>
                <input type="radio" :value="courier.cid" v-model="chosenCourier" />
                <span>{{ courier.fio }}</span>
              </label>
            </li>
          </ul>
          <hr class="line" />
          <div class="back-wrap">
            <button class="continue" @click="toggleModals()" type="button">Выбрать</button>
          </div>
        </div>
        <div class="modal-content" v-else>
          У вас пока нет курьеров, с которыми вы
          <a href="/cabinet/staffCouriers" target="_blank">работаете напрямую</a>. Вы можете
          добавить курьера в штат после выполнения им Вашей доставки!
        </div>
      </div>
    </div>
  </ModalUi>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import ModalUi from '@features/UI/ModalUi.vue'

export default {
  name: 'CouriersModal',
  components: { ModalUi },
  data: () => ({
    localCrmList: [],
    defaultRadio: {
      cid: null,
      fio: 'Найти курьера (по умолчанию)',
      city: 2,
      crm_visible_common_stock: 0,
      isDefault: true,
    },
  }),
  computed: {
    ...mapState(GENERAL_STORE, ['chosenCrmCourier', 'order']),
    ...mapGetters(GENERAL_STORE, ['user']),
    chosenCourier: {
      get() {
        return this.chosenCrmCourier
      },
      set(value) {
        this.updateState({ key: 'chosenCrmCourier', value })
      },
    },
    filteredLocalCrmList() {
      return this.localCrmList.filter(
        courier => +this.order.city === courier.city || courier.hasOwnProperty('isDefault')
      )
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['toggleModals', 'updateState']),
  },
  created() {
    if (this.user.crm_couriers.length) {
      this.localCrmList = this.localCrmList.concat(this.user.crm_couriers)
      this.localCrmList.unshift(this.defaultRadio)

      if (this.chosenCrmCourier === null) {
        this.updateState({ key: 'chosenCrmCourier', value: this.localCrmList[0].cid })
      }
    }
  },
}
</script>

<style></style>
